import type { ConceptBrief } from "./ConceptType";

const LS_KEY_PREFIX = "longfans.concept.catalog.";
const TTL_MS = 10 * 60 * 1000;

interface ConceptCatalogCacheEntry {
  cachedAt: number;
  list: ConceptBrief[];
}

function storageKey(spaceProductId: string): string {
  return `${LS_KEY_PREFIX}${spaceProductId.trim()}`;
}

export function readConceptCatalogCache(spaceProductId: string): ConceptBrief[] | null {
  if (typeof localStorage === "undefined") {
    return null;
  }
  const key = storageKey(spaceProductId);
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as ConceptCatalogCacheEntry;
    if (!parsed || !Array.isArray(parsed.list) || typeof parsed.cachedAt !== "number") {
      return null;
    }
    if (Date.now() - parsed.cachedAt > TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return parsed.list;
  } catch {
    return null;
  }
}

export function writeConceptCatalogCache(spaceProductId: string, list: ConceptBrief[]): void {
  if (typeof localStorage === "undefined") {
    return;
  }
  const entry: ConceptCatalogCacheEntry = {
    cachedAt: Date.now(),
    list,
  };
  try {
    localStorage.setItem(storageKey(spaceProductId), JSON.stringify(entry));
  } catch {
    /* quota exceeded 等场景忽略 */
  }
}
